import React, { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import WebMfa from '@chegg/mfa';
import { setMfaError } from "../../store/reducer";
import { setLoading } from "../../store/sharedActions";
import { setMfa } from "../../store/sharedActions";
import { trigger } from "../../lib/clientCallback";
var Mfa = function Mfa() {
  var mfa = useAppSelector(function (state) {
    return state.mfa;
  });
  var backView = useAppSelector(function (state) {
    return state.backView;
  });
  var frontView = useAppSelector(function (state) {
    return state.frontView;
  });
  var showBack = useAppSelector(function (state) {
    return state.backView;
  });
  var dispatch = useAppDispatch();
  var authProvider = mfa.authProvider;
  var onView = showBack && backView || frontView;
  var setIsPending = useCallback(function () {
    dispatch(setLoading({
      loading: true,
      onView: onView
    }));
  }, [onView, dispatch]);
  var mfaErrorCb = useCallback(function () {
    dispatch(setMfaError());
  }, [dispatch]);
  var mfaSuccessCb = useCallback(function (tokens) {
    dispatch(setMfa({
      showMfa: false
    }));
    dispatch(setLoading({
      loading: false,
      onView: onView
    }));
    trigger({
      type: 'auth',
      payload: {
        action: onView,
        status: 'success',
        data: tokens
      }
    });
  }, [dispatch, onView]);
  var hideMfa = useCallback(function () {
    dispatch(setMfa({
      showMfa: false
    }));
    dispatch(setLoading({
      loading: false,
      onView: onView
    }));
  }, [dispatch, onView]);
  if (!mfa.showMfa) return null;
  return /*#__PURE__*/React.createElement(WebMfa, {
    userUuid: mfa.mfaPayload.uuid,
    email: mfa.mfaPayload.email,
    mfaToken: mfa.mfaPayload.mfa_token,
    authProvider: authProvider,
    onMfaClose: hideMfa,
    onLoadingCb: setIsPending,
    onSuccessCb: mfaSuccessCb,
    onErrorCb: mfaErrorCb
  });
};
export default Mfa;